import styled from 'styled-components';

export const EllipsisSpan = styled.span`
    max-width: ${props => props.width || '100%'};
    overflow: hidden;
    vertical-align: top;
    display: inline-block;
    text-overflow: ellipsis;
    color: ${props => props.color || 'initial'};
`;